/* eslint-disable no-lonely-if */
/* eslint-disable no-useless-return */
/* eslint-disable no-debugger */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-use-before-define */
import {
  DeleteOutlined,
  EditOutlined,
  PlusCircleFilled,
  StarOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import { useLazyQuery, useQuery } from "@apollo/client";
import {
  Alert,
  Button,
  Cascader,
  Dropdown,
  Form,
  Image,
  Input,
  Select,
  Skeleton,
  Switch,
  Tag,
  Tooltip,
} from "antd";
import _, { isEmpty, isString } from "lodash";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { UserContext } from "../../amplify/authenticator-provider";
import {
  GET_FILTER_USERS,
  GET_OPPORTUNITTIES_TYPES,
  GET_OPPORTUNITY_STATUS_NEW,
  GET_OPPORTUNITY_USER_TYPE,
} from "../../graphql/query";
import useCrmIntegration from "../../hooks/useCrmIntegration";
import useCrm from "../../hooks/useCrm";
import { AccessPermissionAction } from "../../library/constants";
import { checkAccessPermission } from "../../library/helpers";
import { firstUpperCaseWordParser } from "../../library/utils";
import UserSelector from "../commonComponents/userSelector";
import { VehicleFormModal, parseExtraData, SELL_SIDE_INTERESTS } from "./vehicleModal";
import {
  OpportunityTypeCascader,
  OpportunityStatusCascader,
} from "./cascaders/OpportunityCascaders";
import CustomEmpty from "../commonComponents/CustomEmpty";
import useDepartment from "../../hooks/useDepartment";
import { getSessionStorage } from "../../utils/storages";
import { CRM_TYPES } from "../../constants/crmConstants";
import {
  getRootOppTypeId,
  getUserAllowedRootOppTypeIds,
  isUserUnscoped,
} from "../../library/oppTypeScoping";

/**
 * Enforce the "single vehicle is primary" rule: when exactly one non-deleted
 * vehicle remains on the opportunity, mark it primary. Mutates the passed
 * object (a cloned state) in place. No-op for 0 or multiple vehicles.
 */
const ensureSinglePrimary = state => {
  const active = (state?.vehiclesOfInterest || []).filter(v => !v?.isDeleted);
  if (active.length === 1) active[0].isPrimary = true;
};

// Helper function to flatten the nested tree structure to flat array with parentStatusId
const flattenStatusTree = (nodes, parentId = null) => {
  let flattened = [];
  nodes.forEach(node => {
    flattened.push({
      id: node.key,
      name: node.name,
      isDefault: node.isDefault,
      parentStatusId: parentId,
    });
    if (node.childs && node.childs.length > 0) {
      flattened = flattened.concat(flattenStatusTree(node.childs, node.key));
    }
  });
  return flattened;
};

// TODO: these two flags, `getParentChain` and `fetchUserTypes` below are now
// duplicated in `hooks/useOpportunityUserTypes.js`, which the edit-users dialog
// uses. Move this screen onto that hook and delete the local copies — until
// then a change here has to be mirrored there or the two will disagree about
// which opportunity type the user types come from.
//
// When true, uses parent chain fallback (child -> parent -> grandparent)
// When false, only queries the specific ID
const ENABLE_USER_TYPE_PARENT_FALLBACK = false;
// When true, directly use the topmost parent ID instead of child-to-parent fallback
const USE_ROOT_PARENT_FOR_USER_TYPE = true;

// When true, directly use the topmost parent ID instead of child-to-parent fallback
const USE_ROOT_PARENT_FOR_STATUS = true;

// Tag color per vehicle customerInterest — kept in sync with the opportunity
// layer vehicle display (opportunityLayer.js) so colors match across screens.
const interestTagColor = interest => {
  switch (interest) {
    case "TRADE":
      return "orange";
    case "SELL":
      return "magenta";
    case "BUY":
      return "blue";
    case "SERVICE":
      return "purple";
    default:
      return "magenta";
  }
};

export default function LeadOpportunityInformationForm({
  leadData,
  setleadData,
  lead = {},
  mode,
  form,
  selectedOpportunity,
  setselectedOpportunity,
  newOpportunity,
  setnewOpportunity,
  showOpportunityDropdown = true,
  defaultOpportunity,
  leadSources,
  crmIntegration,
  leadSourcesLoader,
  settingsProp,
  persistVehicle,
  // Active root opp_type tab from the activity center. When set in
  // ADD mode: (a) the opportunity-type cascader is filtered to only
  // the user's permitted roots AND further to this active root, and
  // (b) the cascader defaults to this root id so the form starts with
  // the matching tab pre-selected.
  selectedOppTypeId,
}) {
  const settings = useMemo(() => {
    if (settingsProp) return settingsProp;
    if (lead?.location?.settings) {
      return isString(lead?.location?.settings)
        ? JSON.parse(lead?.location?.settings)
        : lead?.location?.settings;
    }
    return null;
  }, [lead?.location?.settings, settingsProp]);

  const [opportunityStatusList, setOpportunityStatusList] = useState([]);
  const [opportunityTypes, setopportunityTypes] = useState([]);
  const [userTypes, setuserTypes] = useState([]);
  const [userSearch, setuserSearch] = useState("");
  const [userList, setuserList] = useState([]);
  const { user } = useContext(UserContext);
  const [noError, setNoError] = useState(true);

  const userLocations = (user.locations || []).map(el => ({
    ...el,
    key: +el?.location?.id,
    name: el?.location?.title,
  }));

  const currentLocationId = sessionStorage.getItem("currentLocationId");

  const currentLocation = userLocations.find(location =>
    mode === "EDIT"
      ? +selectedOpportunity?.location?.id || +currentLocationId === +location?.location?.id
      : +leadData?.location === +location?.location?.id ||
        +currentLocationId === +location?.location?.id
  );

  const renderDepartmentField =
    currentLocation?.location?.settings?.SHOULD_SHOW_DEPARTMENT_FIELD_IN_LEAD_AND_OPPORTUNITY ||
    false;

  const [getUserTypes, { loading: userTypesLoader }] = useLazyQuery(GET_OPPORTUNITY_USER_TYPE, {
    fetchPolicy: "network-only",
  });

  // Fetch departments from API
  const { departments, fetching } = useDepartment({
    locationId: getSessionStorage("currentLocationId"),
    customSkipCondition: !renderDepartmentField,
  });

  // Fetch user types with optional parent chain fallback
  const fetchUserTypes = async opportunityTypeId => {
    if (!opportunityTypeId) {
      setuserTypes([]);
      return;
    }

    // Get the complete parent chain
    const parentChain = getParentChain(opportunityTypeId, opportunityTypes);

    // Determine which IDs to query based on flags
    let idsToQuery;
    if (USE_ROOT_PARENT_FOR_USER_TYPE) {
      // Use only the topmost parent (last item in chain)
      idsToQuery = [parentChain[parentChain.length - 1]];
    } else if (ENABLE_USER_TYPE_PARENT_FALLBACK) {
      // Use full parent chain for child-to-parent fallback
      idsToQuery = parentChain;
    } else {
      // Only query the specific ID
      idsToQuery = [opportunityTypeId];
    }

    for (const typeId of idsToQuery) {
      try {
        // eslint-disable-next-line no-await-in-loop
        const result = await getUserTypes({
          variables: {
            locationId: +lead?.location?.id || +sessionStorage?.getItem("currentLocationId"),
            companyId: user.company.id,
            opportunityTypeId: +typeId,
          },
        });

        if (result.data?.getOpportunityUserTypes?.length > 0) {
          setuserTypes(result.data.getOpportunityUserTypes);
          return;
        }
      } catch (error) {
        // Continue to next parent in chain (if fallback enabled)
      }
    }

    // If we get here, no user types were found
    setuserTypes([]);
    setNoError(false);
  };
  const { loading: opportunityTypesLoader } = useQuery(GET_OPPORTUNITTIES_TYPES, {
    variables: {
      industryId: 1,
    },
    onCompleted: res => {
      // ``getOpportunityTypes`` returns a FLAT array of all types where
      // each row carries ``parentType`` linking it back up the chain.
      // The cascader (OpportunityTypeCascader) groups these by their
      // root parent for display.
      //
      // In ADD mode for a scoped user, keep only the rows whose ROOT
      // parent is in the user's permitted set — i.e., if the user is
      // only permitted for Sales (root id 1), drop every row whose
      // walk-to-root id is anything else. Both parent rows and child
      // rows are walked the same way via ``getRootOppTypeId``.
      //
      // EDIT mode keeps the full list so an existing opp under a root
      // the user can no longer act on still renders its label path.
      // Unscoped users (no scoping departments) see everything.
      const userAllowed = getUserAllowedRootOppTypeIds(user);
      const unscoped = isUserUnscoped(user);
      const fullList = res.getOpportunityTypes || [];
      const filtered =
        mode === "ADD" && !unscoped
          ? fullList.filter(row => {
              const rootId = getRootOppTypeId(row);
              return rootId && userAllowed.has(Number(rootId));
            })
          : fullList;
      setopportunityTypes(filtered);
    },
  });

  const canAddEditOpportunity = checkAccessPermission(
    AccessPermissionAction.LEAD_OPPORTUNITY_MANAGEMENT_ADD_EDIT
  );

  const { loading: userLoader } = useQuery(GET_FILTER_USERS, {
    variables: {
      companyId: user.company.id,
      search: userSearch,
    },
    onCompleted: res => {
      setuserList(res.getUsers.data);
    },
  });

  const [getOpportunityStatus, { loading: opportunityStatusLoader }] = useLazyQuery(
    GET_OPPORTUNITY_STATUS_NEW,
    {
      fetchPolicy: "cache-first", // Use cache when available, fallback to network
      variables: {
        opportunityTypeId: null, // This will be set when calling the query
        locationIds: (sessionStorage?.getItem("currentLocationId") || "").includes(",")
          ? sessionStorage
              ?.getItem("currentLocationId")
              ?.split(",")
              .map(el => +el)
          : [+sessionStorage?.getItem("currentLocationId")],
      },
      onCompleted: resp => {
        // Filter out null/invalid items and ensure clean data structure
        const validStatuses = (resp.getOpportunityStatusNew || []).filter(
          item => item && item.key && item.name
        );
        // Flatten hierarchical data to flat array with parentStatusId
        // so OpportunityStatusCascader can render status icons correctly
        setOpportunityStatusList(flattenStatusTree(validStatuses));
      },
    }
  );

  // Build complete parent chain for a given type ID
  const getParentChain = (typeId, types) => {
    const chain = [typeId]; // Start with the current type

    // Find a type by ID
    const findTypeById = id => {
      return types.find(type => +type.id === +id); // Using strict comparison
    };

    let currentId = typeId;
    while (currentId) {
      const currentType = findTypeById(currentId);

      if (currentType && currentType.parentType && currentType.parentType.id) {
        const parentId = currentType.parentType.id;
        chain.push(parentId);
        currentId = parentId;
      } else {
        break;
      }
    }

    return chain;
  };

  const fetchOpportunityStatus = async (
    selectedValue,
    autoSelectFromOpportunity = false,
    statusIdToRestore = null,
    setStateCallback = null
  ) => {
    if (!selectedValue) {
      setOpportunityStatusList([]);
      return;
    }

    // Get the complete parent chain once
    const parentChain = getParentChain(selectedValue, opportunityTypes);

    // If flag is true, use only the topmost parent (last item in chain)
    // Otherwise, use full chain for child-to-parent fallback
    const idsToQuery = USE_ROOT_PARENT_FOR_STATUS
      ? [parentChain[parentChain.length - 1]]
      : parentChain;

    // eslint-disable-next-line no-await-in-loop
    for (const typeId of idsToQuery) {
      try {
        // eslint-disable-next-line no-await-in-loop
        const result = await getOpportunityStatus({
          variables: {
            opportunityTypeId: typeId,
            locationIds: (sessionStorage?.getItem("currentLocationId") || "").includes(",")
              ? sessionStorage
                  ?.getItem("currentLocationId")
                  ?.split(",")
                  .map(el => +el)
              : [+sessionStorage?.getItem("currentLocationId")],
          },
        });

        if (result.data?.getOpportunityStatusNew?.length > 0) {
          // Found data, auto-select status if flag is true and we have a status to restore
          const statusToRestore = statusIdToRestore || selectedOpportunity?.opportunityStatusId;

          if (autoSelectFromOpportunity && statusToRestore) {
            // Check if the status exists in the fetched list
            const statusExists = result.data.getOpportunityStatusNew.some(
              status => +status.key === +statusToRestore
            );

            if (statusExists) {
              // Auto-select the status and update state
              setTimeout(() => {
                form.setFieldsValue({
                  opportunityStatusId: statusToRestore,
                });
                // Also update the state to keep it in sync if callback provided
                if (setStateCallback) {
                  setStateCallback(prev => ({
                    ...prev,
                    opportunityStatusId: statusToRestore,
                  }));
                }
              }, 100);
            }
          }
          return;
        }
      } catch (error) {
        // Continue to next parent in chain
      }
    }

    // If we get here, no statuses were found for any level in the hierarchy
    setOpportunityStatusList([]);
  };

  useEffect(() => {
    if (user.company.id && opportunityTypes?.length > 0) {
      const opportunityTypeId =
        mode === "EDIT" ? +selectedOpportunity?.opportunityTypeId : +leadData?.opportunityTypeId;
      if (opportunityTypeId) {
        fetchUserTypes(opportunityTypeId);
      }
    }
  }, [
    user.company.id,
    mode,
    selectedOpportunity?.opportunityTypeId,
    leadData?.opportunityTypeId,
    opportunityTypes,
  ]);

  // "+ Add Vehicle" dropdown: the four opportunity vehicle types. Selecting one
  // opens the VehicleFormModal (Inventory / Vehicle Request tabs) for that type.
  // ADD-mode default for opportunityTypeId: pick a sensible default
  // under the active activity-center tab's root so the cascader opens
  // pre-populated. Runs once both ``selectedOppTypeId`` is present AND
  // the flat type list has loaded. Skipped if the form already has a
  // type id (don't overwrite user edits).
  //
  // Default resolution (priority order):
  //   1. The lead's most-recent existing opp under this root — its
  //      ``opportunityTypeId`` is usually a child leaf, so the cascader
  //      displays a full parent → child path.
  //   2. The first CHILD row under the active root in the type list.
  //      Children show up as rows with ``parentType.id === root``.
  //   3. The root row itself (parent-only selection). Works when the
  //      cascader is configured to allow parent selection; otherwise
  //      this is the last-resort fallback.
  useEffect(() => {
    if (mode !== "ADD") return;
    if (!selectedOppTypeId) return;
    if (!opportunityTypes || opportunityTypes.length === 0) return;
    const currentValue = form.getFieldValue("opportunityTypeId");
    if (currentValue) return;

    const rootIdNum = Number(selectedOppTypeId);

    // 1. lead's most-recent existing opp under this root.
    const leadOpps = lead?.leadOpportunities || [];
    const recentMatchingOpp = [...leadOpps]
      .filter(o => Number(getRootOppTypeId(o?.opportunityType)) === rootIdNum)
      .sort((a, b) => {
        const ta = new Date(a?.updatedDate || a?.createdDate || 0).getTime();
        const tb = new Date(b?.updatedDate || b?.createdDate || 0).getTime();
        return tb - ta;
      })[0];

    // 2. first child row under this root.
    const firstChildRow = opportunityTypes.find(row => Number(row?.parentType?.id) === rootIdNum);

    // 3. fallback to the root row itself.
    const rootRowAvailable = opportunityTypes.some(row => Number(row?.id) === rootIdNum);

    const defaultTypeId =
      recentMatchingOpp?.opportunityTypeId ||
      firstChildRow?.id ||
      (rootRowAvailable ? rootIdNum : null);

    if (!defaultTypeId) return;

    form.setFieldsValue({ opportunityTypeId: +defaultTypeId });
    if (typeof setleadData === "function") {
      setleadData(prev => ({ ...prev, opportunityTypeId: +defaultTypeId }));
    }
    fetchOpportunityStatus(+defaultTypeId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode, selectedOppTypeId, opportunityTypes, lead?.leadOpportunities]);

  const items = [
    { key: "BUY", label: "Buy" },
    { key: "SELL", label: "Sell" },
    { key: "TRADE", label: "Trade" },
    { key: "SERVICE", label: "Service" },
  ];

  // if mode is edit,selectedOpportunity is not null, and newopportunity is false, then manage the state of selectedOpportunity
  return (
    <div className="flex flex-wrap">
      <span className="bg-[#F8FAFC] p-2 w-full flex flex-row justify-between items-center text-sm font-[600] text-grey-700 ">
        Opportunity Information
        {mode === "EDIT" && (
          <div className="flex mt-2 flex-row items-center gap-1">
            <Switch
              disabled={!canAddEditOpportunity}
              onChange={checked => {
                setnewOpportunity(checked);
                if (checked) {
                  setselectedOpportunity({ leadOpportunityUsers: [], vehiclesOfInterest: [] });
                  form.resetFields();
                  form.setFieldValue("location", sessionStorage.getItem("currentLocationId"));
                } else {
                  setselectedOpportunity(defaultOpportunity);
                  const activeUsers = (defaultOpportunity?.leadOpportunityUsers || []).filter(
                    user => user.isActive
                  );
                  const ownerObj = {};
                  for (let index = 0; index < activeUsers.length; index++) {
                    const element = activeUsers[index];
                    ownerObj[`leadOpportunityUsers-${element.id}`] = element.userId;
                  }
                  form.setFieldsValue({
                    ...defaultOpportunity,
                    opportunityName: defaultOpportunity?.name,
                    // location: defaultOpportunity?.location?.id,
                    opportunityTypeId: +defaultOpportunity?.opportunityTypeId,
                    opportunitySourceId: +defaultOpportunity?.opportunitySourceId,
                    opportunityStatusId: +defaultOpportunity?.opportunityStatusId,
                    // ...vehicleObj,
                    ...ownerObj,
                  });
                }
              }}
              checked={newOpportunity}
            />{" "}
            New Opportunity
          </div>
        )}
      </span>
      <OpportunityForm
        mode={mode}
        newOpportunity={newOpportunity}
        state={mode === "EDIT" ? selectedOpportunity : leadData}
        setState={mode === "EDIT" ? setselectedOpportunity : setleadData}
        form={form}
        opportunityTypes={opportunityTypes}
        leadStatusList={opportunityStatusList}
        leadSources={leadSources}
        userLoader={userLoader}
        leadSourcesLoader={leadSourcesLoader}
        opportunityStatusLoader={opportunityStatusLoader}
        opportunityTypesLoader={opportunityTypesLoader}
        userTypesLoader={userTypesLoader}
        userTypes={userTypes}
        userList={userList}
        items={items}
        lead={lead}
        noError={noError}
        setNoError={setNoError}
        showOpportunityDropdown={showOpportunityDropdown}
        defaultOpportunity={defaultOpportunity}
        crmIntegration={crmIntegration}
        canAddEditOpportunity={canAddEditOpportunity}
        fetchOpportunityStatus={fetchOpportunityStatus}
        departments={departments}
        departmentLoader={fetching}
        renderDepartmentField={renderDepartmentField}
        settings={settings}
        persistVehicle={persistVehicle}
      />
    </div>
  );
}
function OpportunityForm({
  mode,
  newOpportunity,
  state,
  setState,
  form,
  opportunityTypes,
  leadStatusList,
  leadSources,
  userTypesLoader,
  userTypes,
  userList,
  items,
  lead,
  showOpportunityDropdown,
  noError,
  setNoError,
  defaultOpportunity,
  leadSourcesLoader,
  userLoader,
  canAddEditOpportunity,
  opportunityTypesLoader,
  opportunityStatusLoader,
  fetchOpportunityStatus,
  departments,
  departmentLoader,
  renderDepartmentField,
  settings,
  persistVehicle,
  refetchOpportunity,
}) {
  const crmIntegration = useCrmIntegration();
  const { getOpprDetails } = useCrm();
  const { user } = useContext(UserContext);
  useEffect(() => {
    if (mode === "ADD" && newOpportunity) {
      if ((sessionStorage.getItem("currentLocationId") || "").includes(",")) {
        form.setFieldsValue({ location: null });
      }
    } else if (mode === "EDIT") {
      if ((sessionStorage.getItem("currentLocationId") || "").includes(",")) {
        form.setFieldsValue({ location: null });
      }
      form.setFieldsValue({ location: lead?.location?.id || lead?.lead?.location?.id });
    }
  }, [newOpportunity, lead, mode]);

  useEffect(() => {
    if (mode === "EDIT" && state) {
      form.setFieldsValue({ location: +state?.location?.id });

      // Set user form fields when state changes
      const activeUsers = (state?.leadOpportunityUsers || []).filter(user => user.isActive);
      if (activeUsers.length > 0) {
        const ownerObj = {};
        for (let index = 0; index < activeUsers.length; index++) {
          const element = activeUsers[index];
          ownerObj[`leadOpportunityUsers-${element.id}`] = element.userId;
        }
        form.setFieldsValue(ownerObj);
      }

      // Fetch opportunity statuses if we have an opportunity type (for edit mode)
      // Only fetch if we don't already have statuses loaded
      if (state.opportunityTypeId && opportunityTypes?.length > 0 && leadStatusList?.length === 0) {
        fetchOpportunityStatus(state.opportunityTypeId);
      }
    }
  }, [state, mode, opportunityTypes]);

  const handleOpportunityChange = value => {
    const opprtunity = lead?.leadOpportunities?.find(item => item.id === value);
    setState(opprtunity);
    const ownerObj = {};
    for (let index = 0; index < opprtunity.leadOpportunityUsers.length; index++) {
      const element = opprtunity.leadOpportunityUsers[index];
      ownerObj[`leadOpportunityUsers-${element.id}`] = element.userId;
    }
    form.setFieldsValue({
      ...opprtunity,
      opportunityName: opprtunity.name,
      opportunityTypeId: +opprtunity.opportunityTypeId,
      opportunitySourceId: +opprtunity.opportunitySourceId,
      opportunityStatusId: +opprtunity.opportunityStatusId,
      ...ownerObj,
    });
  };
  const DeleteIcon = ({ index, settempLeadData, className = "" }) => (
    <DeleteOutlined
      disabled={!canAddEditOpportunity}
      className={`text-red-500 cursor-pointer ${className}`}
      onClick={() => {
        settempLeadData(prev => {
          const temp = structuredClone(prev);
          if (_.has(temp.vehiclesOfInterest[index], "id")) {
            temp.vehiclesOfInterest[index] = {
              ...temp.vehiclesOfInterest[index],
              isDeleted: true,
            };
          } else {
            temp.vehiclesOfInterest.splice(index, 1);
          }
          // If only one vehicle remains, it must be the primary.
          ensureSinglePrimary(temp);
          return temp;
        });
      }}
    />
  );
  // ---- Add/Edit Vehicle modal (replaces the legacy inline vehicle forms) ----
  const [vehicleModal, setVehicleModal] = useState({
    open: false,
    mode: "ADD",
    index: null,
    customerInterest: null,
    initialVehicle: null,
  });

  const openAddVehicle = customerInterest =>
    setVehicleModal({
      open: true,
      mode: "ADD",
      index: null,
      customerInterest,
      initialVehicle: null,
    });

  const openEditVehicle = (index, vehicle) =>
    setVehicleModal({
      open: true,
      mode: "EDIT",
      index,
      customerInterest: vehicle.customerInterest,
      initialVehicle: vehicle,
    });

  const closeVehicleModal = () => setVehicleModal(prev => ({ ...prev, open: false }));

  // Apply vehicles to local state: replace at index (EDIT) or append (ADD),
  // preserving primary/delete flags and the rest of the array.
  const applyVehiclesToState = vehicles =>
    setState(prev => {
      const temp = structuredClone(prev);
      if (!Array.isArray(temp.vehiclesOfInterest)) temp.vehiclesOfInterest = [];
      if (vehicleModal.mode === "EDIT" && vehicleModal.index != null) {
        // Edit replaces the target; any extra selections are appended.
        const [first, ...rest] = vehicles;
        temp.vehiclesOfInterest[vehicleModal.index] = {
          ...temp.vehiclesOfInterest[vehicleModal.index],
          ...first,
        };
        rest.forEach(v => temp.vehiclesOfInterest.push(v));
      } else {
        vehicles.forEach(vehicle => {
          // First vehicle on the opportunity becomes primary by default.
          const isFirst = temp.vehiclesOfInterest.filter(v => !v.isDeleted).length === 0;
          temp.vehiclesOfInterest.push({ ...vehicle, isPrimary: vehicle.isPrimary || isFirst });
        });
      }
      ensureSinglePrimary(temp);
      return temp;
    });

  // Save handler for the vehicle modal. When editing an existing opportunity,
  // each vehicle is persisted to the backend immediately (create/update VOI),
  // local state is updated with the returned id, and the opportunity is
  // refetched. Otherwise (new-opportunity flow / unresolved ids) the vehicle
  // stays local and is persisted with the opportunity. Returns false to keep
  // the modal open on error. Accepts a single vehicle or an array.
  const handleVehicleSave = async vehicleOrVehicles => {
    const vehicles = Array.isArray(vehicleOrVehicles) ? vehicleOrVehicles : [vehicleOrVehicles];
    if (!vehicles.length) return true;

    // No persist handler -> local only (backward-compatible).
    if (!persistVehicle) {
      applyVehiclesToState(vehicles);
      return true;
    }

    const results = [];
    for (let i = 0; i < vehicles.length; i++) {
      // eslint-disable-next-line no-await-in-loop
      results.push(await persistVehicle(vehicles[i]));
    }

    // Brand-new opportunity (or unresolved ids) -> keep local, save later.
    if (results.some(r => r?.deferred)) {
      applyVehiclesToState(vehicles);
      return true;
    }
    // Any backend failure -> keep modal open so the user can retry.
    if (results.some(r => r?.error)) return false;

    // Persisted: merge the returned id (so a later opportunity save updates
    // rather than re-creates) and keep the values the user just entered.
    // We update local state only — NOT a full lead/opportunity refetch — so the
    // vehicle list refreshes in place and the user stays on the edit form (the
    // Add Vehicle drawer closes on its own via the modal's onClose).
    const saved = vehicles.map((v, i) => ({ ...v, id: results[i]?.saved?.id ?? v.id }));
    applyVehiclesToState(saved);
    return true;
  };

  const setPrimaryVehicle = index =>
    setState(prev => {
      const temp = structuredClone(prev);
      const prevIndex = temp.vehiclesOfInterest.findIndex(v => v?.isPrimary);
      if (prevIndex !== -1) temp.vehiclesOfInterest[prevIndex].isPrimary = false;
      temp.vehiclesOfInterest[index].isPrimary = true;
      return temp;
    });

  const leadUserTypeIds = (state?.leadOpportunityUsers || [])
    .map(item => +item?.userTypeId || null)
    .sort();
  const userTypeIds = (userTypes || []).map(item => +item.id).sort();
  useEffect(() => {
    if (mode === "EDIT") {
      setNoError(_.isEqual(leadUserTypeIds, userTypeIds));
    }
  }, [mode, userTypes]);
  const handleOpportunityId = lead => getOpprDetails({ opportunity: lead }).label;
  const userLocations = (user.locations || []).map(el => ({
    ...el,
    key: +el?.location?.id,
    name: el?.location?.title,
  }));

  return (
    <div className="flex justify-between w-full flex-wrap mt-2">
      {mode === "EDIT" && !newOpportunity && showOpportunityDropdown && (
        <Form.Item className="w-full" label="Select Opportunity">
          <Select value={state.id} onChange={value => handleOpportunityChange(value)}>
            {(lead?.leadOpportunities || []).map((item, index) => (
              <Select.Option key={index} value={item.id}>
                {item.name} ({handleOpportunityId(item)})
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      )}
      <Form.Item
        rules={[{ required: true, message: "Please select a location" }]}
        className="w-full"
        name="location"
        label="Location"
      >
        <Select
          name="location"
          // value={state.location}
          onChange={value => setState({ ...state, location: value, departmentId: null })}
          disabled={
            !canAddEditOpportunity && newOpportunity
              ? false
              : !(sessionStorage.getItem("currentLocationId") || "").includes(",") ||
                mode === "EDIT"
          }
        >
          {(userLocations || []).map(item => (
            <Select.Option key={`loc_key_${item?.key}`} value={item?.key}>
              {item?.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      {renderDepartmentField && (
        <Form.Item
          // rules={[{ required: true, message: "Please select a department" }]}
          className="w-full"
          name="departmentId"
          label="Department"
        >
          <Select
            name="departmentId"
            placeholder="Select department"
            onChange={value => setState({ ...state, departmentId: +value })}
            loading={departmentLoader}
            labelRender={({ label }) => (departmentLoader ? "Loading..." : label)}
          >
            {(departments || []).map(item => (
              <Select.Option key={item?.id} value={+item?.id}>
                {item?.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      )}
      <Form.Item
        className="w-full"
        name="opportunityName"
        rules={[
          {
            required: mode === "EDIT" && !newOpportunity,
            message: "Opportunity name is required",
          },
        ]}
        label="Opportunity Name"
      >
        <Input
          disabled={!canAddEditOpportunity}
          placeholder="Enter opportunity name"
          name="opportunityName"
          // value={state.opportunityName}
          onChange={e => setState({ ...state, opportunityName: e.target.value })}
        />
      </Form.Item>
      <Form.Item
        className="w-full"
        name="opportunityTypeId"
        rules={[{ required: true, message: "Opportunity type is required" }]}
        label="Opportunity Type"
      >
        <OpportunityTypeCascader
          opportunityTypes={opportunityTypes}
          opportunityTypesLoader={opportunityTypesLoader}
          form={form}
          canAddEditOpportunity={canAddEditOpportunity}
          value={state.opportunityTypeId}
          onChange={value => {
            // Save the current status ID before clearing (for EDIT mode restoration)
            const currentStatusId = state.opportunityStatusId;

            // Update opportunity type and clear opportunity status in single setState
            setState(prev => ({
              ...prev,
              opportunityTypeId: value,
              opportunityStatusId: null,
            }));
            form.setFieldsValue({ opportunityStatusId: null });

            // Fetch opportunity statuses with fallback and auto-select if in EDIT mode
            // Pass the saved status ID so it can be restored if it exists in the new list
            fetchOpportunityStatus(
              value,
              mode === "EDIT" && !newOpportunity,
              currentStatusId,
              setState
            );
          }}
          allowParentSelection={crmIntegration === "DS"}
          expandTrigger="click"
          mode={mode}
          currentOpportunityTypeId={
            mode === "EDIT" && !newOpportunity ? defaultOpportunity?.opportunityTypeId : null
          }
        />
      </Form.Item>

      <Form.Item
        className="w-full"
        name="opportunityStatusId"
        rules={[{ required: true, message: "Opportunity status is required" }]}
        label="Opportunity Status"
      >
        <OpportunityStatusCascader
          expandTrigger="click"
          leadStatusList={leadStatusList}
          showCheckedStrategy="SHOW_CHILD"
          opportunityStatusLoader={opportunityStatusLoader}
          form={form}
          canAddEditOpportunity={canAddEditOpportunity}
          value={state.opportunityStatusId}
          onChange={value => setState(prev => ({ ...prev, opportunityStatusId: value }))}
          allowParentSelection={crmIntegration === CRM_TYPES.DEALERSOCKET}
          statusHistory={
            settings?.SKIP_OPPORTUNITY_STATUS_HISTORY_CREATION && mode === "EDIT" && !newOpportunity
              ? state?.statusHistory || []
              : []
          }
          showStatusIcons={
            !!settings?.SKIP_OPPORTUNITY_STATUS_HISTORY_CREATION &&
            mode === "EDIT" &&
            !newOpportunity
          }
          dropdownClassName="max-h-[300px] overflow-y-auto"
          displayRender={(_labels, selectedOptions) => {
            if (!selectedOptions?.length) {
              return (
                <span className="flex-row-centered cursor-pointer text-xs font-[400] gap-1">
                  {state?.opportunityStatus?.name || "N/A"}
                </span>
              );
            }
            const lastOption = selectedOptions[selectedOptions.length - 1];
            const iconData = settings?.SKIP_OPPORTUNITY_STATUS_HISTORY_CREATION
              ? lastOption?.statusIconDisplay
              : null;
            const textPath = selectedOptions.map(o => o.textLabel || o.label).join(" / ");
            return (
              <span className="flex-row-centered cursor-pointer text-xs font-[400] gap-1">
                {iconData && (
                  <img
                    src={iconData.iconSrc}
                    alt={iconData.iconAlt}
                    style={{ width: 14, height: 14, flexShrink: 0 }}
                  />
                )}
                {textPath}
              </span>
            );
          }}
        />
      </Form.Item>

      <Form.Item
        className="w-full"
        name="opportunitySourceId"
        rules={[{ required: true, message: "Opportunity source is required" }]}
        label="Opportunity Source"
        getValueProps={val => ({ value: leadSourcesLoader ? [] : val })}
      >
        <Cascader
          name="opportunitySourceId"
          disabled={!canAddEditOpportunity}
          loading={leadSourcesLoader}
          fieldNames={{ label: "name", value: "key", children: "childs" }}
          expandTrigger="click"
          options={leadSources}
          placement="bottomLeft"
          changeOnSelect
          showSearch
          onChange={value => {
            if (value && value.length > 0)
              setState({ ...state, opportunitySourceId: value[value.length - 1] });
            else {
              setState({ ...state, opportunitySourceId: null });
            }
          }}
          // getPopupContainer={trigger => trigger.parentElement}
          placeholder={
            leadSourcesLoader
              ? "Opportunity sources are being fetched..."
              : "Select Opportunity Source"
          }
          optionRender={option => (
            <div
              style={{
                whiteSpace: "normal",
                wordBreak: "break-word",
                minWidth: "200px",
                maxWidth: "400px",
              }}
            >
              {option.name}
            </div>
          )}
        />
      </Form.Item>
      <span className="bg-[#F8FAFC] mt-3 mb-2 p-2 w-full text-sm font-[600] text-grey-700">
        Opportunity Users
      </span>
      <div className="flex flex-col w-full ">
        {userTypesLoader ? (
          <Skeleton className="my-2" active />
        ) : (
          (() => {
            const isAddOrNewOpportunity = newOpportunity || mode === "ADD";
            const activeLeadUsers = (state?.leadOpportunityUsers || []).filter(el => el.isActive);

            // Determine which data source to use
            // For edit mode: always use activeLeadUsers if they exist (regardless of userTypes)
            // For add/new mode: use userTypes
            const shouldUseExistingUsers = !isAddOrNewOpportunity && activeLeadUsers.length > 0;
            const dataSource = shouldUseExistingUsers ? activeLeadUsers : userTypes;

            return isEmpty(dataSource) ? (
              <div className="my-2">
                <CustomEmpty description="No opportunity users available" />
              </div>
            ) : (
              dataSource.map((item, index) => {
                const isUserType = !item.userType;
                const userTypeName = isUserType ? item.name : item.userType.name;
                const isRequired = isUserType
                  ? !isEmpty(item.isRequired) && item.isRequired
                  : !isEmpty(item.required) && item.required;

                // For existing users, use their leadOpportunityUser ID for the form field name
                // This matches what was set in form.setFieldsValue
                const formFieldName = !isUserType ? `leadOpportunityUsers-${item.id}` : undefined;

                return (
                  <UserSelector
                    key={isUserType ? index : `user-${item.id}`}
                    required={isRequired}
                    name={formFieldName}
                    placeholder={`Select ${userTypeName}`}
                    handleUsersSelection={value =>
                      setState(prev => {
                        const temp = [...prev.leadOpportunityUsers];
                        if (isUserType) {
                          temp[index] = {
                            ...temp[index],
                            userTypeId: +item.id,
                            userId: value,
                            userType: item.name,
                          };
                        } else {
                          temp[index] = {
                            ...temp[index],
                            userId: value,
                          };
                        }
                        return { ...prev, leadOpportunityUsers: temp };
                      })
                    }
                    allowClear
                    multiple={false}
                    showAll={false}
                    disabled={!canAddEditOpportunity}
                    validation
                    item={isUserType ? item : { name: userTypeName, item: { user: item.user } }}
                    extraQueryParams={{
                      isAllLocationUsers: true,
                    }}
                  />
                );
              })
            );
          })()
        )}
      </div>
      <div className="bg-[#F8FAFC] flex flex-row mt-3 mb-2 justify-between items-center p-2 w-full">
        <span className="text-sm font-[600] text-grey-700">Opportunity Vehicles</span>
        <Dropdown
          menu={{
            items,
            onClick: e => openAddVehicle(e.key),
          }}
          disabled={!canAddEditOpportunity}
        >
          <Button type="text" className="text-brand-500 flex flex-row items-center">
            <PlusCircleFilled /> Add Vehicle
          </Button>
        </Dropdown>
      </div>
      <div className="flex flex-col w-full gap-2 mt-2">
        {(state?.vehiclesOfInterest || [])?.map((item, index) =>
          item.isDeleted ? (
            <Alert
              type="info"
              showIcon
              message={
                <>
                  <span className="font-[600]">
                    {item.year || ""} {item.make || ""} {item.model || ""}
                  </span>
                  <span> will be deleted when you save the opportunity</span>
                </>
              }
              key={index}
              closable
              closeIcon={
                <Tooltip title="Undo delete">
                  <UndoOutlined
                    onClick={() =>
                      setState(prev => {
                        const temp = structuredClone(prev);
                        temp.vehiclesOfInterest[index] = {
                          ...temp.vehiclesOfInterest[index],
                          isDeleted: false,
                        };
                        return temp;
                      })
                    }
                    className="text-[#1677ff]"
                  />
                </Tooltip>
              }
            />
          ) : (
            <div
              key={index}
              className="border-[1px] border-grey-200 border-solid rounded-lg flex flex-row justify-between items-center gap-2 py-4 pl-6"
            >
              <div className="flex flex-row items-center gap-2">
                <div className="flex flex-col items-center justify-center gap-2">
                  <Image
                    src={
                      item.media?.[0]?.mediaUrl ||
                      "https://funnel-webapp-uploads.s3.amazonaws.com/prod/images/generic-car-not-available-image.png"
                    }
                    height="48px"
                    width="48px"
                    className="rounded-full"
                    fallback="https://funnel-webapp-uploads.s3.amazonaws.com/prod/images/generic-car-not-available-image.png"
                  />
                  <Tag color={interestTagColor(item.customerInterest)} className="border-none">
                    {firstUpperCaseWordParser(item.customerInterest || "")}
                  </Tag>
                </div>
                <div className="flex flex-col items-start">
                  <span className="text-sm font-[600] text-grey-700">
                    {item.year || ""} {item.make || ""} {item.model || ""}
                  </span>
                  <span className="text-xs font-[400] text-[#64748B]">
                    {item.vin || "VIN not available"}
                  </span>
                  <span className="text-xs font-[400] text-[#64748B]">
                    {item.stockNumber ? `Stock #${item.stockNumber}` : "Stock Number not available"}
                  </span>
                  <span className="text-xs font-[400] text-[#64748B]">
                    {(() => {
                      // Min/max come from local fields or the extra_data JSON (server).
                      const extra = parseExtraData(item.extraData);
                      // Service vehicles carry no price at all (their preferences
                      // are odometer/plate/warranty) — show the odometer instead.
                      if (item.customerInterest === "SERVICE") {
                        const odometer = item.odometer ?? extra.odometer;
                        return odometer == null || odometer === ""
                          ? "Odometer not available"
                          : `Odometer: ${odometer}`;
                      }
                      // Sell/Trade vehicles store an expected price, not a buyer
                      // budget — label it accordingly.
                      const isSellSide = SELL_SIDE_INTERESTS.includes(item.customerInterest);
                      const label = isSellSide ? "Expected Price" : "Budget";
                      const min =
                        item.priceRangeMin ??
                        extra.priceRangeMin ??
                        item.expectedPrice ??
                        extra.expectedPrice ??
                        item.budget;
                      const max = item.priceRangeMax ?? extra.priceRangeMax;
                      if (min == null || min === "") return `${label} not available`;
                      return max != null && max !== ""
                        ? `${label}: $${min} - $${max}`
                        : `${label}: $${min}`;
                    })()}
                  </span>
                </div>
              </div>
              <div className="flex flex-row items-center gap-3 mr-3">
                <Tooltip title="Set as primary vehicle">
                  <StarOutlined
                    disabled={!canAddEditOpportunity}
                    onClick={() => canAddEditOpportunity && setPrimaryVehicle(index)}
                    className={`scale-100 cursor-pointer ${
                      item.isPrimary ? "text-yellow-400" : "bg-transparent"
                    }`}
                  />
                </Tooltip>
                <Tooltip title="Edit vehicle">
                  <EditOutlined
                    disabled={!canAddEditOpportunity}
                    onClick={() => canAddEditOpportunity && openEditVehicle(index, item)}
                    className="scale-100 cursor-pointer text-[#1677ff]"
                  />
                </Tooltip>
                <DeleteIcon className="scale-100" index={index} settempLeadData={setState} />
              </div>
            </div>
          )
        )}
      </div>
      {vehicleModal.open && (
        <VehicleFormModal
          open={vehicleModal.open}
          mode={vehicleModal.mode}
          customerInterest={vehicleModal.customerInterest}
          initialVehicle={vehicleModal.initialVehicle}
          onSave={handleVehicleSave}
          onClose={closeVehicleModal}
        />
      )}
    </div>
  );
}
